import {
  RolodexEntryJson,
  RolodexEntryType,
} from 'types/rolodex/rolodexEntries'
import { parseNumber, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

/**
 * Represents a Component Deficiency entry
 * Used to track deficiencies found on components with their risk assessment
 */
export class GeckoComponentDeficiency extends GeckoEntryBase<
  {
    title: string
    description?: string
    riskScore?: number
    likelihood?: number
    consequence?: number
  },
  {
    organization: string
    site: string
    unit: string
    component?: string
    [RolodexEntryType.RISK_ASSESSMENT]?: string
  }
> {
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        title: parseString(json.data.title) ?? 'Untitled Deficiency',
        description: parseString(json.data.description),
        riskScore: parseNumber(json.data.riskScore),
        likelihood: parseNumber(json.data.likelihood),
        consequence: parseNumber(json.data.consequence),
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
        unit: parseString(json.tags.unit) ?? '',
        component: parseString(json.tags.component),
        [RolodexEntryType.RISK_ASSESSMENT]: parseString(
          json.tags[RolodexEntryType.RISK_ASSESSMENT]
        ),
      },
      {}
    )
  }

  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoComponentDeficiency(json)
  }
}
